import React from 'react';
import type { RecommendationsServingConfig } from '@noths/polaris-client-listings-api';
import { LazyRender } from '@noths/polaris-client-ribbons-design-system';
import { ProductCarousel } from '@noths/polaris-design-system-candidate-components';

import type { RecommendedProductsViewModel } from 'src/components/layouts/hooks/useRecommendedProductsViewModel';
import { RecommendedProductsCarouselContainer } from './containers/RecommendedProductsCarouselContainer';

const LAZY_LOAD_MARGIN = '200px';

export interface RecommendedProductsCarouselSectionProps extends RecommendedProductsViewModel {
  heading: string;
  readonly servingConfig: RecommendationsServingConfig;
}

/**
 * Wraps a recommendations rail in the lazy boundary that holds its client-side
 * fetch back until the rail is near the viewport.
 *
 * The heading lives here rather than only on the container so that one source
 * names both the placeholder and the carousel it becomes, and so it reaches the
 * server-rendered HTML rather than appearing with the products.
 */
export const RecommendedProductsCarouselSection = ({
  heading,
  ...containerProps
}: RecommendedProductsCarouselSectionProps) => (
  /* The placeholder is the carousel's own loading state rather than a separate
     skeleton, so nothing about the rail changes shape when the real one mounts. */
  <LazyRender
    options={{ rootMargin: LAZY_LOAD_MARGIN }}
    placeholder={<ProductCarousel heading={heading} products={null} />}
  >
    <RecommendedProductsCarouselContainer {...containerProps} heading={heading} />
  </LazyRender>
);
